<template>
  <footer class="p-t-44">
    <b-container class="main-container">
      <b-row class="line m-b-20">
        <b-col
          lg="3"
          md="6"
          sm="12"
          class="pl-0"
        >
          <Logo />
        </b-col>
        <b-col
          lg="3"
          md="6"
          sm="12"
        >
          <Company />
        </b-col>
        <b-col
          lg="3"
          md="6"
          sm="12"
        >
          <ContactUs />
        </b-col>
        <b-col
          lg="3"
          md="6"
          sm="12"
        >
          <FollowStatecsOn />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div>
            <p
              class="mb-2
              text-primary-montserrat text-center blue-dark l-h-17 f-s-14 font-weight-bold"
            >
              <span class="mr-3">
                Privacy Policy
              </span>
              <span>
                Terms of Service
              </span>
            </p>
            <p class="f-s-14 main-grey l-h-17 text-center">
              © 2021 STATECS | All Rights Reserved
            </p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
import Logo from '@/components/layout/headerItems/Logo';
import Company from './footerItems/Company';
import ContactUs from './footerItems/ContactUs';
import FollowStatecsOn from './footerItems/FollowStatecsOn';

export default {
  name: 'Footer',
  components: {
    Company,
    Logo,
    ContactUs,
    FollowStatecsOn,
  },
  data() {
    return {
    };
  },
};
</script>
